import styled from "styled-components";

/**
 * ログイン画面のスタイルコンポーネント
 * 元のPHPデザイン（login関連）を参考に作成
 */
const LoginStyles = {
  // メインラッパー
  LoginContainer: styled.div`
    //min-height: 100vh;
    background: #000 url("/images/header_bg.jpg") 50% 0 no-repeat;
    font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
    position: relative;
    padding-bottom: 0px;
  `,

  // ボディ背景
  BodyBackground: styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,
  // ヘッダー
  Header: styled.div`
    height: 500px;
    width: 100%;
    /* background: #999 url("/images/header_bg.png") no-repeat 50%; */
  `,

  // メインコンテナ
  Container: styled.div`
    width: 1000px;
    margin: 0 auto;
    height: 440px;
  `,

  // ロゴ
  Logo: styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 10px 0px 14px 0px;

    img {
      max-height: 48px;
      margin-left: 8%;
    }
  `,

  // メインエリア
  Main: styled.div`
    display: flex;
    width: 100%;
    height: 380px;
    padding-top: 60px;
  `,

  // ログインボックス
  LoginBox: styled.div`
    float: left;
    width: 50%;
    height: 380px;
    padding-top: 0px;
  `,

  // ログインフォーム
  LoginForm: styled.div`
    background-color: rgba(0, 0, 0, 0.7);
    width: 400px;
    height: 220px;
    margin: 20px auto;
    padding: 10px;
    color: #fff;
    border: 1px solid #3366ff;
  `,

  // ログインタイトル
  LoginTitle: styled.dt`
    font-size: 14px;
    background-color: rgba(51, 102, 255, 0.5);
    padding: 8px 7px;
    /* border-bottom: 1px solid #3366ff; */
  `,

  // ログインコンテンツ
  LoginContent: styled.dd`
    margin: 0;
  `,

  // ログインテーブル
  LoginTable: styled.table`
    margin: 15px 0 0;
    width: 350px;
    margin-left: 20px;

    td,
    th {
      text-align: right;
      padding: 8px 6px;
      font-size: 14px;
    }

    th {
      width: 6em;
      color: #fff;
    }

    label {
      top: -5px;
    }

    input[type="text"] {
      border: 1px solid #3366ff !important;
      background: #E4EBFF !important;
      border-radius: 0 !important;
      width: 250px;
      height: 30px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #E4EBFF inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #E4EBFF inset !important;
        background: #E4EBFF !important;
      }
    }

    input[type="password"] {
      border: 1px solid #3366ff !important;
      background: #E4EBFF !important;
      border-radius: 0 !important;
      width: 250px;
      height: 30px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #E4EBFF inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #E4EBFF inset !important;
        background: #E4EBFF !important;
      }
    }
  `,

  // 入力フィールド
  Input: styled.input`
    width: 250px;
    height: 22px;
    border: 1px solid #3366ff !important;
    background: #E4EBFF !important;
    padding: 2px 5px;
    font-size: 14px;
  `,

  // ログインボタン
  LoginButton: styled.button`
    width: 100px;
    height: 25px;
    color: #fff;
    background: #3366ff;
    border: 1px solid #3366ff;
    margin: auto;
    display: block;
    font-weight: bold;
    font-size: 13px;
    cursor: pointer;

    &:hover {
      background: #1c3dc0;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  `,

  // エラーメッセージ
  ErrorMessage: styled.div`
    color: #c00;
    font-size: 12px;
    text-align: center;
    margin: 0 0 5px;
    padding: 5px;
    background: #ffe4e4;
    border: 1px solid #ff9999;
    border-radius: 3px;
  `,

  // メッセージエリア
  MessageArea: styled.div`
    float: right;
    width: 50%;
    height: 440px;
    margin-top: -17px;
  `,

  // メッセージコンテンツ
  MessageContent: styled.div`
    padding: 0 25px;
    margin: 0 15px;
    height: 200px;
    color: #fff;
    font-size: 14px;
    text-shadow: 0px 0px 3px #000;

    h1 {
      padding: 25px 25px 0;
      display: block;
      border-bottom: 1px solid #fff;
      margin: 10px 0px 0px;
      font-size: 19px;
      font-weight: bold;
      color: #fff;
      text-shadow: 0px 0px 3px #000;
      margin-left: -30px;
    }

    p {
      margin-top: 10px;
    }

    strong {
      font-size: 18px;
      color: #ff0;
    }

    span {
      font-size: 0.9em;
    }

    .emergency {
      display: block;
      margin-top: 1.6em;
    }

    .emergency a {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      margin-left: 50px;
      padding: 0px 10px;
      color: white;
      text-decoration: underline;
    }
  `,

  // ラッパー
  Wrap: styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,

  // フッター
  Footer: styled.div`
    width: 680px;
    margin: 50px 250px 80px;
    padding: 15px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 10px;
    text-align: left;
    color: #333;

    a {
      text-decoration: underline;
      color: blue;
    }

    .contact {
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
    }

    strong {
      color: #c00;
      font-size: inherit;
    }

    span {
      font-size: 12px;
      font-weight: normal;
    }
  `,

  // メインコンテンツ
  MainContent: styled.div`
    /* #mainの背景色をコメントアウトして、bodyの背景画像を透かす */
    min-height: 120px;
    padding: 0 0 40px;
    position: relative;
    flex: 1;
  `,

  // フッターコピーライトコンテナ
  FooterCopyrightContainer: styled.div`
    flex-shrink: 0;
    width: 100%;
  `,

  // 京都府自動車整備商工組合のボディ背景
  BodyBackgroundKyotoSeibi: styled.div`
    margin: 0;
    padding: 0;
    text-align: center;
    background-color: #FFFFFF;
    min-width: 900px;
    background-image: url("/images/Bg_1Z_01.png");
    background-position: top center;
    background-repeat: repeat-y;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,

  // 京都府自動車整備商工組合のメインコンテナ
  ContainerKyotoSeibi: styled.div`
    width: 920px;
    min-width: 900px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  `,
  // 京都府自動車整備商工組合のヘッダー
  HeaderKyotoSeibi: styled.div`
    height:60px;
  `,
  // 京都府自動車整備商工組合のロゴ
  Logo1KyotoSeibi: styled.div`
    display: flex;
    align-items: center;
  `,
  // 京都府自動車整備商工組合のロゴ
  Logo2KyotoSeibi: styled.p`
    font-size: 14px;
    color: #444;
    line-height: 60px;
    margin: 0;
    padding: 0;
  `,
  // ログイン部分用のコンテナ
  ContainerLoginKyotoSeibi: styled.div`
    width: 920px;
    min-width: 900px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    flex: 1;
  `,
  // 京都府自動車整備商工組合のログインボックス
  LoginBoxKyotoSeibi: styled.div`
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  // 京都府自動車整備商工組合のログインフォーム
  LoginFormKyotoSeibi: styled.div`
    width: 450px;
    padding: 25px;
    background: #B7D100;
    border-radius: 10px;
    text-align: center;
  `,
  // 京都府自動車整備商工組合のログインコンテンツ
  LoginContentKyotoSeibi: styled.dd`
    margin: 0;
  `,
  // 京都府自動車整備商工組合のログインテーブル
  LoginTableKyotoSeibi: styled.table`
    margin: 15px 0 0;
    width: 350px;
    margin-left: 20px;

    td {
      padding: 8px 6px;
      font-size: 18px;
    }

    th {
      text-align: right;
      color: #000000;
      font-size: 14px;
      font-weight: normal;
      white-space: nowrap;
      min-width: 80px;
      padding-right: 10px;
    }

    label {
      top: -5px;
    }

    input[type="text"] {
      border: 1px solid #767676 !important;
      background: #FFFFFF !important;
      border-radius: 0 !important;
      width: 300px;
      height: 36px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #FFFFFF inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #FFFFFF inset !important;
        background: #FFFFFF !important;
      }
    }

    input[type="password"] {
      border: 1px solid #767676 !important;
      background: #FFFFFF !important;
      border-radius: 0 !important;
      width: 300px;
      height: 36px;
      padding: 4px 3px;
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px #FFFFFF inset !important;
        -webkit-text-fill-color: #000 !important;
        box-shadow: 0 0 0 30px #FFFFFF inset !important;
        background: #FFFFFF !important;
      }
    }
  `,
  // 京都府自動車整備商工組合のエラーメッセージ
  ErrorMessageKyotoSeibi: styled.div`
    color: #000000;
    font-size: 14px;
    text-align: center;
    margin: 0 0 5px;
    padding: 5px;
  `,
  // 京都府自動車整備商工組合の入力フィールド
  InputKyotoSeibi: styled.input`
    width: 300px;
    font-size: 18px;
    line-height: 36px;
    height: 36px;
  `,
  // 京都府自動車整備商工組合のログインボタン
  LoginButtonKyotoSeibi: styled.button`
    display: inline-block;
    background: #397f00 url("/images/arrow_important.png") no-repeat 10px 50%;
    color: #FFF;
    height: 33px;
    border-style: solid;
    border-width: 1px;
    border-color: #7FBD26 #1c3f00 #1c3f00 #7FBD26;
    border-radius: 5px;
    text-align: center;
    line-height: 33px;
    font-size: 18px;
    font-weight:bold;
    padding:0 10px 0 30px;
    margin-top:20px;
    
    &:hover {
      background: #7FBD26;
    }

    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  `,
};

export default LoginStyles;
